import React from "react";

export const TopBar = () => {
    return (
        <div className="row border-bottom">
            <nav className="navbar navbar-static-top white-bg" role="navigation" style={{marginBottom: 0}}>
                <div className="navbar-header" style={{height: 60}}>
                    <h2 className={'mt-3 ml-3 font-bold'}>Global Open Drug Data</h2>
                </div>
            </nav>
        </div>
    )
}
